import { ConfData3 } from "../../const/const";
import { configDataConstants } from "../actions/types";
const initialState = {
    original: ConfData3,
    current: ConfData3,
};
export const configDataReducer = (state = initialState, action) => {
    switch (action.type) {
        case configDataConstants.SET_CONFIG_DATA:
            return Object.assign(Object.assign({}, state), { original: action.payload });
        case configDataConstants.SET_CURRENT_CONFIG_DATA:
            return Object.assign(Object.assign({}, state), { current: action.payload });
        case configDataConstants.RESET_CURENT_CONFIG_DATA:
            return Object.assign(Object.assign({}, state), { current: Object.assign({}, state.original) });
        default:
            return state;
    }
};
